import type { AgencyRef } from '@gat-ship/types'
import { getAgencyRefsRequest } from '../model/agency-api-calls'
import { createListRefDataSource } from './create-list-ref-datasource'

/**
 * Shared agency ref cache for select/combobox pickers. A module-level singleton
 * like `currency-datasource`; the agency-specific SignalR wiring lives in the
 * `useAgencyRefDataSource` composable wrapper. Replaces the agency-only
 * `RefDataProvider`/`useGlobalRefData` Pinia store.
 */
export const agencyRefDataSource = createListRefDataSource<AgencyRef>({
  fetch: getAgencyRefsRequest,
  getKey: (agency) => agency.id
})
